import defaultAvatar from '../assets/images/avatar.png';

export const getAvatar = (avatarSrc: string = '') => avatarSrc || defaultAvatar;
